import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React, { Component } from 'react';
import { Grid as MuiGrid, withStyles, Typography, Link as MuiLink } from '@material-ui/core';
import DateRangeEnum from '@kailona/core/src/enums/DateRange.enum';
import { ProfileManager } from '@kailona/core';
var Grid = withStyles({
  root: {
    margin: '0 5px'
  }
})(MuiGrid);
var Link = withStyles(function (theme) {
  return {
    root: {
      color: theme.palette.gray40.main,
      '&:hover': {
        textDecoration: 'none',
        color: theme.palette.primary.main
      },
      '&.active': {
        color: theme.palette.primary.main
      }
    }
  };
})(MuiLink);

var TimeRangeFilter = /*#__PURE__*/function (_Component) {
  _inherits(TimeRangeFilter, _Component);

  var _super = _createSuper(TimeRangeFilter);

  function TimeRangeFilter(props) {
    var _this;

    _classCallCheck(this, TimeRangeFilter);

    _this = _super.call(this, props);
    _this.state = {
      dateRange: '1M'
    };
    return _this;
  }

  _createClass(TimeRangeFilter, [{
    key: "handleDateRangeChange",
    value: function handleDateRangeChange(dateRange) {
      this.setState({
        dateRange: dateRange
      });

      if (typeof this.props.handleDateRangeChange === 'function') {
        return this.props.handleDateRangeChange(dateRange);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var patientDob = ProfileManager && ProfileManager.activeProfile && ProfileManager.activeProfile.patientDob; // Hide MAX if birth date was not entered

      var dateRanges = Object.values(DateRangeEnum).filter(function (r) {
        return r !== DateRangeEnum.MAX || !!patientDob;
      });
      return /*#__PURE__*/React.createElement(Grid, {
        container: true,
        style: {
          justifyContent: 'flex-end'
        }
      }, dateRanges.map(function (dateRange, index) {
        return /*#__PURE__*/React.createElement(Grid, {
          key: index,
          item: true
        }, /*#__PURE__*/React.createElement(Link, {
          href: "#",
          className: _this2.state.dateRange === dateRange ? 'active' : '',
          onClick: function onClick() {
            return _this2.handleDateRangeChange(dateRange);
          }
        }, dateRange));
      }));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return TimeRangeFilter;
}(Component);

export { TimeRangeFilter as default };
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Grid, "Grid", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/components/Timeline/TimeRangeFilter.js");
  reactHotLoader.register(Link, "Link", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/components/Timeline/TimeRangeFilter.js");
  reactHotLoader.register(TimeRangeFilter, "TimeRangeFilter", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/components/Timeline/TimeRangeFilter.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();